<script setup>
import { ref } from 'vue';
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summarReportsRef = ref(null);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};
</script>

<template>
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-tag"
        accent="amber"
        :title="$t('LABEL_REPORTS.HEADER')"
        :subtitle="$t('LABEL_REPORTS.DESCRIPTION')"
      >
        <template #actions>
          <V4Button
            :label="$t('LABEL_REPORTS.DOWNLOAD_LABEL_REPORTS')"
            icon="i-ph-download-simple"
            size="sm"
            @click="onDownloadClick"
          />
        </template>
      </PageHeader>
    </template>

    <SummaryReports
      ref="summarReportsRef"
      action-key="summaryReports/fetchLabelSummaryReports"
      getter-key="labels/getLabels"
      fetch-items-key="labels/get"
      summary-key="summaryReports/getLabelSummaryReports"
      type="label"
    />
  </PageLayout>
</template>
